import angular from 'angular'

import { invoiceGather } from 'redevConfig'

const list = (invoiceGather && invoiceGather.list) || ''
const listPage = list ? require(`redevelopment/input/invoiceGather/${list.templateName}`) : require('./view/list.html')
const invoiceGatherListCtrl = list ? require(`redevelopment/input/invoiceGather/${list.controllerName}`) : require('./invoiceGatherListCtrl.js')
export default angular
    .module('input.financialCounting.invoiceGather', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('input.financialCounting.invoiceGather', {
            url: '/invoiceGather',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'input.financialCounting.invoiceGather.list',
            title: '发票数据采集',
        })
        $stateProvider.state('input.financialCounting.invoiceGather.list', {
            url: '/list',
            template: listPage,
            controller: 'invoiceGatherListCtrl',
        })
    }])
    .controller('invoiceGatherListCtrl', invoiceGatherListCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/input/financialCounting/invoiceGather/index.js